<template>
	<div></div>
	<div class="block-white-rounded d-flex flex-column gap-3">
		<h2 class="h5 mb-0">{{ pll["For a period of"] }}</h2>
		<div class="d-flex justify-content-start">
			<input 
				data-name="month_period"
				:data-value="month_period"
				type="number" v-model="month_period" class="form-control d-inline-flex w-auto max-w-110 me-2 analytics"
			/>
			<custom_select
				data-name="period"
				:data-value="period"
				class="select__analytics"

				v-model="period" :options="period_options"
			/>
		</div>
	</div>
</template>
<script>
import custom_select from "./custom_select.vue";

export default {
	components: {
		custom_select,
	},
	data() {
		return {
			month_period: 1,
			period: 1,
			period_options: [
				{ value: 1, name: this.pll["Months"] }, 
				{ value: 12, name: this.pll["Years"] }
			]
		};
	},
	mounted() {
		this.setPeriod(this.month_period);
	},
	watch: {
		month_period(val) {
			this.setPeriod(val);
		},
		period() {
			this.setPeriod(this.month_period);
		}
	},
	methods: {
        setPeriod(val) {
			let output = val * this.period;
			this.$emit("update", output);
		}
	}
};
</script>
